import type { ConnectorUsage } from "../types";

export function anthropicMessagesUsage(): ConnectorUsage {
  return {
    measures: [
      { measure: "input_tokens", perModel: true },
      { measure: "cache_write_tokens", perModel: true },
      { measure: "cache_read_tokens", perModel: true },
      { measure: "output_tokens", perModel: true },
    ],
  };
}
